import axios from 'axios'

export const api = axios.create({
    baseURL: process.env.VUE_APP_BASE_API_URL,
    withCredentials: false,
    headers: {
        Accept: 'application/json'
    }
})

// Public API - correspond à notre API externe
export const PublicApi = axios.create({
    baseURL: process.env.VUE_APP_BASE_API_EXTERNE_URL,
    withCredentials: false,
    headers: {
        Accept: "application/json",
    },
})